import React, { useState } from 'react';
import {
  Container,
  Typography,
  Grid,
  Paper,
  Tabs,
  Tab,
  Box,
} from '@mui/material';
import BookAppointment from './BookAppointment';
import AppointmentHistory from './AppointmentHistory';

const ClientDashboard: React.FC = () => {
  const [tabValue, setTabValue] = useState(0);

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography 
        variant="h4" 
        gutterBottom
        sx={{ 
          color: 'text.primary',
          fontWeight: 500,
        }}
      >
        Client Dashboard
      </Typography>
      
      <Paper sx={{ 
        p: 3,
        background: (theme) => theme.palette.background.paper,
        backdropFilter: 'blur(20px)',
      }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
          <Tabs 
            value={tabValue} 
            onChange={(_, newValue) => setTabValue(newValue)}
            sx={{
              '& .MuiTab-root': {
                color: 'text.secondary',
                '&.Mui-selected': {
                  color: 'primary.main',
                },
              },
              '& .MuiTabs-indicator': {
                backgroundColor: 'primary.main',
              },
            }}
          >
            <Tab label="Book Appointment" />
            <Tab label="Appointment History" />
          </Tabs>
        </Box>

        {tabValue === 0 && <BookAppointment />}
        {tabValue === 1 && <AppointmentHistory />}
      </Paper>
    </Container>
  );
};

export default ClientDashboard; 